import { useEffect, useState } from "react";

const navLinks = [
  { label: "今日热榜", href: "#hot" },
  { label: "王牌栏目", href: "#columns" },
  { label: "专题节目", href: "#topics" },
  { label: "精选内容", href: "#content" },
  { label: "频道口碑", href: "#reviews" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-8 h-16 md:h-[72px]">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span
            className={`w-9 h-9 md:w-10 md:h-10 rounded-xl flex items-center justify-center bg-primary-500 text-background-50 ${
              scrolled || open ? "" : "shadow-none"
            }`}
          >
            <i className="ri-water-flash-fill text-xl md:text-2xl"></i>
          </span>
          <span
            className={`font-heading font-bold text-xl md:text-2xl tracking-tight ${
              scrolled || open ? "text-foreground-950" : "text-white"
            }`}
          >
            吃瓜频道
          </span>
          <span
            className={`hidden lg:inline-flex text-xs px-2.5 py-1 rounded-full font-medium border ${
              scrolled || open
                ? "bg-primary-100 text-primary-700 border-primary-200"
                : "bg-white/15 text-white border-white/25"
            }`}
          >
            每日更新
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`px-3.5 py-2 text-[15px] font-medium rounded-md transition-colors whitespace-nowrap ${
                scrolled || open
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-white/90 hover:text-white hover:bg-white/10"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            className="ml-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-[15px] font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            投稿 / 互动
          </a>
        </nav>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${
            scrolled || open ? "text-foreground-900 bg-background-100" : "text-white bg-white/15"
          }`}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {open && (
        <nav className="md:hidden px-4 pb-4 bg-background-50/95 backdrop-blur border-t border-background-200">
          <div className="grid grid-cols-2 gap-2 pt-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-4 py-3 rounded-lg bg-background-100 text-foreground-800 text-[15px] font-medium hover:bg-background-200 whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="px-4 py-3 rounded-lg bg-primary-500 text-background-50 text-[15px] font-semibold text-center hover:bg-primary-600"
            >
              投稿 / 互动
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}